import { checkIfStickersTypeApp } from '../../redux/homeActions';
import * as Constants from '../constants/Constants';
import {
  getURLQueryStringAsDictionary,
  isMaskApp,
  isSignageSuiteProduct
} from './HelperFunctions';

export const isTurkeyAccount = () => (dispatch, getState) => {
  if (getState().home.selectedProduct) {
    const { groupType } = getState().home.selectedProduct;

    return (
      getState().modal.storeData.partnerStoreType == Constants.TURKEY_KEY &&
      isLaptopsApp(groupType)
    );
  }
  return false;
};

export const isFranceAccount = () => (dispatch, getState) =>
  getState().modal.storeData &&
  getState().modal.storeData.partnerStoreType == Constants.FRANCE_KEY;

export const isOmenLaptopOfTurkeyAccount = () => (dispatch, getState) => {
  if (getState().home.selectedProduct) {
    return (
      dispatch(isTurkeyAccount()) &&
      getState().home.selectedProduct.sku === 'OMN_01'
    );
  }
  return false;
};

export const checkForDesignCompetition = () => () => {
  const URLString = getURLQueryStringAsDictionary();
  if (URLString.get('design_cmp')) {
    return true;
  }
  return false;
};

export const checkForDesignEnterprise = () => () => {
  const URLString = getURLQueryStringAsDictionary();
  if (URLString.get('design_enterprise')) {
    return true;
  }
  return false;
};

export const isBelgiumAccount = () => (dispatch, getState) => {
  if (getState().home.selectedProduct) {
    const { groupType } = getState().home.selectedProduct;

    return (
      getState().modal.storeData.partnerStoreType == Constants.BELGIUM_KEY &&
      isLaptopsApp(groupType)
    );
  }
  return false;
};

export const isWestcoastAccount = () => (dispatch, getState) => {
  if (getState().home.selectedProduct) {
    const { groupType } = getState().home.selectedProduct;

    return (
      getState().modal.storeData.partnerStoreType == Constants.WESTCOAST_KEY &&
      isLaptopsApp(groupType)
    );
  }
  return false;
};

export const isTurkeyLaptop = () => (dispatch, getState) => {
  const { sessionData, storeData } = getState().modal;
  if (
    sessionData.gsku === 'LPTS' &&
    storeData.partnerStoreType === Constants.TURKEY_KEY
  ) {
    return true;
  }
  return false;
};

export const isOmenLaptop = () => (dispatch, getState) => {
  if (getState().home.selectedProduct) {
    return getState().home.selectedProduct.sku === 'OMN_01';
  }
  return false;
};

export const isLaptopsApp = groupType => {
  if (groupType == 'LPTS') {
    return true;
  }
  return false;
};

export const isShippingDetailsEnabled = () => (dispatch, getState) => {
  if (getState().home.selectedProduct) {
    const { groupType } = getState().home.selectedProduct;
    return (
      getState().modal.envData.is_shipping_details_enabled &&
      isLaptopsApp(groupType)
    );
  }
  return false;
};

export const orderId = () => {
  const URLString = getURLQueryStringAsDictionary();
  return URLString.get('order_id');
};

export const couponCodeValue = () => {
  const URLString = getURLQueryStringAsDictionary();
  if (URLString.get('coupon_code')) {
    return URLString.get('coupon_code');
  }
  if (URLString.get('Coupon_code')) {
    return URLString.get('Coupon_code');
  }
  return null;
};

export const isBannerApp = groupType => groupType == 'BNN';

export const isRollupApp = groupType => groupType == 'RLUP';

export const isWallcoveringApp = category =>
  category == Constants.WALLPAPER_CATEGORY;

export const isCanvasApp = category => category == Constants.CANVAS_CATEGORY;

export const shouldShowSizeList = () => (dispatch, getState) => {
  if (getState().home.selectedProduct) {
    return (
      isBannerApp(getState().home.selectedProduct.groupType) ||
      isRollupApp(getState().home.selectedProduct.groupType) ||
      dispatch(checkIfStickersTypeApp())
    );
  }
  return (
    isWallcoveringApp(getState().modal.envData.category) ||
    isCanvasApp(getState().modal.envData.category)
  );
};

export const canShowPriceDetailsInFinalCheck = () => (dispatch, getState) => {
  if (isSignageSuiteProduct()) {
    const { groupType } = getState().home.selectedProduct;
    return !(isLaptopsApp(groupType) || isMaskApp(groupType));
  }
  return true;
};

export const isToggleViewModeIsSupported = () => () => false;
